import RouterButton from './src/main'

RouterButton.install = function (Vue) {
    Vue.component(RouterButton.name, RouterButton)
}

export default RouterButton